import { PluginOlasioVerificationForm } from '../../../types/plugins';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const runOlasioVerificationForm = (
  constructPost: ConstructPost,
  data: PluginOlasioVerificationForm,
): Promise<NonPaginatedResponse<PluginOlasioVerificationForm> | undefined> =>
  constructPost<NonPaginatedResponse<PluginOlasioVerificationForm>>(
    `${PLUGIN_BASE_PATH}/olasio-verification-form`,
    { data },
  );
